import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const InlineRadioV2 = ({ icon, name, selected, onClick, style, value }) => (
  <WrapperBg
    bgColor={backgroundColors.normalLeft}
    style={style}
    className={selected && 'selected'}>
    <Wrapper onClick={onClick} className={selected && 'selected'}>
      <Input
        bgColor={backgroundColors.normalLeft}
        id={`opt-${value}-${name}`}
        name={name}
        checked={selected}
        onChange={onClick}
      />
      <CenteredBox>{icon}</CenteredBox>
      <Title>{name}</Title>
    </Wrapper>
  </WrapperBg>
)

export default InlineRadioV2

const WrapperBg = styled.div`
  height: 48px;
  border: 1px solid #ececec;
  flex-grow: 1;

  &:hover,
  &.selected {
    border: none;
    background: ${({ bgColor }) => bgColor};
    padding: 1px;
  }
`

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  padding: 12px;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  min-width: 160px;
  cursor: pointer;
  background: #fff;

  &.selected {
    background: linear-gradient(
        0deg,
        rgba(147, 193, 62, 0.1) 0%,
        rgba(147, 193, 62, 0.1) 100%
      ),
      #fff;
  }
`

const CenteredBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  margin: 0;

  svg {
    width: 20px !important;
    height: 20px !important;
  }
`

const Title = styled.span`
  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
  text-transform: capitalize;
`

const Input = styled.input.attrs({
  type: 'radio',
})`
  display: block;
  width: 20px !important;
  height: 20px !important;
  border: none !important;
  position: relative;
  z-index: 1;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    border-radius: 999px;
    border: 1px solid #ececec;
    background: #f9f9f9;
    z-index: 2;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 10px;
    height: 10px;
    top: 5px;
    left: 5px;
    border-radius: 999px;
    background: #fff;
    z-index: 3;
    display: none;
  }

  &:checked {
    &::before {
      background: ${({ bgColor }) => bgColor};
      border: none;
    }
    &::after {
      display: block;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/InlineRadioV2/index.js